module.exports = __webpack_public_path__ + "img/forgetting-curve-dark.48bb2461.svg";